import request from '../utils/request';
import qs from 'qs';
var baseUrl = "/faq";

export const $http = function({url, method, data}) {
  return request({
    url: url + '?platformType='+ (window.localStorage.getItem("openSeeyonVersion") || 'V5'),
    method,
    data
  })
}

/**
 * 获取token ？？？
 */

/**
 * faq 首页
 * 获取分类列表 faqCategories
 * 获取排序列表 faqList
 * 获取置顶列表 topQuestions
 * @param faqDimension [String] 排序方式updateTime=按更新时间,readNum=按阅读量,likeNum=按点赞数
 * @param faqDimensionSort [String] 排序方向 desc=降序,asc=升序
 * @param faqType [Number] 分类id
 * @param faqContent [String] 搜索关键字
 * @param showTypes [Boolean] 是否返回分类列表 第一次加载默认为 true，之后搜索、排序时置为 false
 * @param showTops [Boolean] 是否返回置顶列表 第一次加载默认为 true，之后搜索、排序时置为 false
 * @param pageNum [Number] 分页-当前查询的页码
 * @param pageSize [Number] 分页-每页显示数据条数
 */
 export function getIndexInfo(queryCondition) {
  return $http({
    url: baseUrl + '/faq/v1/getList',
    method: 'post',
    data: queryCondition
  })
}
/**
 * 获取详情页数据
 * @param faqId [Number] 当前问题的 id
 */
 export function getDetailInfo (faqId) {
  return request({
    url: baseUrl + "/faq/v1/detail/" + faqId,
    method: 'post',
    data: ''
  })
}
/**
 * 获取详情页数据
 * @param faqId [Number] 当前问题的 id
 */
 export function checkNoLoginRead (faqId) {
    var url = "/faq/v1/checkNoLoginRead/"
  return request({
    url: baseUrl + url + faqId,
    method: 'post',
    data: ''
  })
}

/**
 * 点赞/取消点赞 无帮助/取消无帮助
 * @param id [Number] 当前问题的 id
 * @param option [String] 取消动作subtract/执行动作add
 * @param type [String] 点赞like/无帮助useless
 */
 export function setLikesOrCancel (faqId, option, type) {
   var data = {
    faqId,
    option,
    type
   };
  return request({
    url: baseUrl + '/faq/v1/giveLike',
    method: 'post',
    data: qs.stringify(data)
  })
}


/**
 * 获取文档跳转地址
 */
 export function getVuepressUrl(vuepressId) {
    var url = "/faq/v1/getVuepressUrl/"
  return request({
    url: baseUrl + url + vuepressId,
    method: 'post',
    data: ''
  })
}


/**
 * 获取分类列表
 */
export function getCategory(){
  return $http({
    url: baseUrl + '/faq/v1/getCategory',
    method: 'post'
  })
}

/**
 * 获取分类列表
 */
export function getTops(){
  return $http({
    url: baseUrl + '/faq/v1/getTops',
    method: 'post'
  })
}